import type {
  AuthenticatedSession,
  AuthorizedSession,
  AuthorizedSessionJSON,
  Principal,
} from '@mntn-dev/auth-types'
import { getPermissions } from '@mntn-dev/authorization-types'

export const authorizeSessionFromPrincipal = (
  session: AuthenticatedSession | AuthorizedSession,
  principal: Principal
): AuthorizedSession => {
  const authorizedSession: AuthorizedSession = {
    ...session,
    principal: {
      ...session.principal,
      ...principal,
      permissions: getPermissions(principal.privileges),
    },
  } as const

  return authorizedSession
}

export const rehydrateAuthorizedSession = (
  session: AuthorizedSession | AuthorizedSessionJSON
): AuthorizedSession => {
  const authorizedSession: AuthorizedSession = {
    ...session,
    principal: {
      ...session.principal,
      permissions: getPermissions(session.principal.privileges),
    },
  } as const

  return authorizedSession
}
